import React from 'react';
import { connect } from 'dva';
import { Button, Drawer, Row, Col } from 'antd';
import Dimio, {DimioComponent, DimioNotice} from 'dimio';

import ListPage from '../../travel/components/ListPage';
import ProductItem from '../../travel/components/ProductItem';

import config from '../config/config';
import "../style/travel.scss"
const {sale} = config;

class SalePage extends DimioComponent {
  constructor(props) {
    super(props);

    this.state = {
      showPanel: false
    };

//    this.onSelect = this.onSelect.bind(this);
    this.onOpenPanel  = this.onOpenPanel.bind(this);
    this.onClosePanel = this.onClosePanel.bind(this);
  }

  componentWillMount() {
    const {dispatch } = this.props;
    this.showLoading();
    const self = this;

    Dimio.load(sale.api.travelList, {
    }).then(res => {
      dispatch({
        type: 'sale/setProducts',
        items: res.data,
        meta:  res.meta
      });

      self.hideLoading();
    }).catch(err => {
      console.error(err);
      self.hideLoading();
    });
  }

  onOpenPanel(){
    this.setState({showPanel: true});
  }

  onClosePanel(){
    this.setState({showPanel: false});
  }

  render() {
    const { core, sale:{orig, items, meta} } = this.props;
    const { showPanel } = this.state;

    return (
      <section>
        <DimioNotice {...core} />

        {meta &&
          <div className=''>
            <Row type="flex" gutter={24} className='mb-3'>
              {(orig && meta.displayItems) &&
               meta.displayItems.map(idx => (
                <Col key={idx} xs={24} sm={8}>
                  {orig[idx] &&
                  <ProductItem
                    item={orig[idx]}
                    sale={true} />
                  }
                </Col>
              ))}

            </Row>
            <Row type="flex" justify="center">
              <Col xs={24} md={8}>
                <Button className='btn-block' onClick={this.onOpenPanel} >他のセールも見る</Button>
              </Col>
            </Row>
          </div>
        }

        <Drawer
          width={'100%'}
          placement="right"
          closable={true}
          onClose={this.onClosePanel}
          visible={showPanel}
        >
          <ListPage
            model='sale'
            items={items}
            onClose={this.onClosePanel}
          />
        </Drawer>
      </section>
    );
  }
}

export default connect(({ core, sale }) => ({
  core, sale
}))(SalePage);



// WEBPACK FOOTER //
// ./src/pages/sale/components/SalePage.js